import { Mic, MicOff } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * VoiceDictationButton
 *
 * Single toggle button — click to start listening, click again to stop.
 * When listening, the button pulses red. When the browser doesn't support
 * speech recognition (e.g. Firefox), renders a disabled "Voice (unavailable)"
 * button with a tooltip.
 */
export function VoiceDictationButton({ isListening, isSupported, onToggle }) {
  if (!isSupported) {
    return (
      <Button
        variant="outline"
        size="sm"
        disabled
        className="btn-3d opacity-60"
        title="Voice dictation requires Chrome, Edge, or Safari"
        data-testid="voice-dictation-btn"
      >
        <MicOff className="w-4 h-4 mr-1" />
        <span className="text-xs">Voice</span>
      </Button>
    );
  }

  return (
    <Button
      variant={isListening ? "default" : "outline"}
      size="sm"
      onClick={onToggle}
      className={
        isListening
          ? "bg-red-600 hover:bg-red-700 text-white animate-pulse"
          : "btn-3d"
      }
      title={
        isListening
          ? "Stop voice dictation"
          : "Start voice dictation — click a cell, then speak digits. Say 'next game' or a dollar value to jump."
      }
      data-testid="voice-dictation-btn"
    >
      <Mic className="w-4 h-4 mr-1" />
      <span className="text-xs">{isListening ? "Listening…" : "Voice"}</span>
    </Button>
  );
}
